import moment from "moment-timezone";
import { messageApiService } from "@/services/message-api.service";

import {
    LOADING, SET_MESSAGES,
    SET_SELECTED_MESSAGE,
    SET_SELECTED_DOCUMENT,
    SET_PAGINATION,
    SET_ERROR,
    SET_EMAIL_ADDRESES,
    SET_SELECTEDCLAIM_ATTACHMENTS,
    SET_CLAIM_MESSAGES_UNREAD,
    SET_MESSAGE_PREVIEW,
    SET_DOCUMENT_TYPES,
    UPDATE_SELECTEDCLAIM_ATTACHMENT,
    SET_CLAIM_MESSAGE_UNCOMPLETED_COUNT
} from './messageStoreMutationTypes'

const formatCreatedDates = (utc, uk) => {
    if (utc && uk) {
        return (
            moment.tz(uk, "Europe/London").format("MMM Do YY, h:mm:ss a") +
            " (" +
            moment.utc(utc).format("MMM Do YY, h:mm:ss a") +
            ")"
        );
    }
    return null;
}

const state = () => ({
    isLoading: false,
    messages: [],
    claimMessageUncompletedCount: null,
    claimsMessagesUnread: [],
    emailAddresses: [],
    selectedMessage: {},
    selectedDocument: {},
    selectedClaimAttachments: [],
    pagination: {},
    messagePreview: null,
    errors: null,
    documentTypes: [],

    messageDataListCols: [
        {
            key: "documentDateCreatedDisplay",
            display: "Date UK (UTC)",
            showSort: true
        },
        {
            key: "taskDateCompletedDisplay",
            display: "Date Completed",
            showSort: true
        },
        {
            key: "from",
            display: "From",
            showSort: true
        },
        {
            key: "messageTags",
            display: "Tags"
        },
        {
            key: "subject",
            display: "Subject",
            showSort: true
        },
        {
            key: "to",
            display: "To"
        }
        //{
        //    key: "taskCompleted",
        //    display: "Completed"
        //}
    ],

    claimsCols: [
        {
            key: 'insuranceLineName',
            display: 'Insurance Line'
        },
        {
            key: 'resellerName',
            display: 'Reseller'
        },
        {
            key: 'claimReference',
            display: 'Claim Reference'
        },
        {
            key: 'relatedReference',
            display: 'Related Reference'
        },
        {
            key: 'productName',
            display: 'Product'
        },
        {
            key: 'claimType',
            display: 'Claim Type'
        },
        {
            key: 'dateCreated',
            display: 'Claim Submitted Date',
            showSort: true
        },
        {
            key: 'incidentDate',
            display: 'Incident Date',
            showSort: true
        },
        {
            key: 'messageDate',
            display: 'Message Date',
            showSort: true
        },
        {
            key: 'number',
            display: 'Policy Number'
        },
        {
            key: 'email',
            display: 'Claimant'
        },
        {
            key: 'claimStatus',
            display: 'Claim Status'
        },
        {
            key: 'claimDecision',
            display: 'Claim Decision'
        },
        {
            key: 'imeiNos',
            display: 'IMEIs'
        },
        {
            key: 'serailNos',
            display: 'Serials'
        }
    ],

    logErrors: false
});

const getters = {
    dataListCols: state => state.messageDataListCols,
    claimsListCols: state => state.claimsCols,
    messages: state => {
        let { messages } = state
        if (messages && messages.length > 0) {
            return messages.map(m => {
                return {
                    ...m,
                    documentDateCreatedDisplay: formatCreatedDates(
                        m.documentDateCreatedUTC,
                        m.documentDateCreatedUK
                    ),
                    taskDateCompletedDisplay: formatCreatedDates(
                        m.dateCompletedUTC,
                        m.dateCompletedUK
                    ),
                    messageTags: m.tags ? m.tags.join(", ") : null
                };
            });
        } else {
            return []
        }
    },
    emailAddresses: state => state.emailAddresses,
    selectedMessage: state => state.selectedMessage,
    selectedEmailDocument: state => state.selectedDocument,
    pagination: state => state.pagination,
    isLoading: state => state.isLoading,
    errors: state => state.errors,
    lastError: state => {
        let { errors } = state
        if (errors && errors.length > 0) {
            return errors[errors.length - 1]
        }
        return null
    },
    selectedClaimAttachments: state => {
        return state.selectedClaimAttachments
    },
    claimsMessagesUnread: ( state, getters, rootState ) => {
        return rootState.claimsList
        //return state.claimsMessagesUnread
    },
    claimsMessagesTaskUncompleted: (state, getters, rootState) => {
        return rootState.claimsList
    },
    messagePreview: state => state.messagePreview,
    documentTypes: state => state.documentTypes,
    claimMessageUncompletedCount: state => state.claimMessageUncompletedCount
};

const mutations = {
    [LOADING](state, payload) {
        state.isLoading = payload
    },
    [SET_MESSAGES](state, payload) {
        state.messages = payload
    },
    [SET_EMAIL_ADDRESES](state, payload) {
        state.emailAddresses = payload
    },
    [SET_SELECTED_MESSAGE](state, payload) {
        state.selectedMessage = payload
    },
    [SET_SELECTED_DOCUMENT](state, payload) {
        state.selectedDocument = payload
    },
    [SET_PAGINATION](state, payload) {
        state.pagination = payload
    },
    [SET_ERROR](state, payload) {
        if (state.logErrors == true) {
            if (!state.errors) {
                state.errors = []
            }
            state.errors.push(payload)
        }
    },
    [SET_SELECTEDCLAIM_ATTACHMENTS](state, payload) {
        state.selectedClaimAttachments = payload
    },
    [SET_CLAIM_MESSAGES_UNREAD](state, payload) {
        state.claimsMessagesUnread = payload
    },
    [SET_MESSAGE_PREVIEW](state, payload) {
        state.messagePreview = payload
    },
    [SET_DOCUMENT_TYPES](state, payload) {
        state.documentTypes = payload
    },
    [UPDATE_SELECTEDCLAIM_ATTACHMENT](state, payload) {
        console.log(payload)
        let arr = state.selectedClaimAttachments.map(a => {
            if (a.id == payload.id) {
                return payload
            } else {
                return a
            }
        })
        console.log(arr)
        state.selectedClaimAttachments = arr
    },
    [SET_CLAIM_MESSAGE_UNCOMPLETED_COUNT](state, payload) {
        state.claimMessageUncompletedCount = payload ? payload.count : null
    }
};

const actions = {
    resetMessages({ commit }) {
        commit(SET_MESSAGES, [])
        commit(SET_EMAIL_ADDRESES, [])
        commit(SET_PAGINATION, {})
        commit(SET_SELECTEDCLAIM_ATTACHMENTS, [])
        commit(SET_CLAIM_MESSAGE_UNCOMPLETED_COUNT, null)
    },
    fetchMessages({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .findWithoutClaim(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data, pagination } = apiResponse
                            commit(SET_MESSAGES, data)
                            commit(SET_PAGINATION, pagination)

                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    fetchMessagesForClaim({ commit }, payload) {
        commit(LOADING, true)
        commit(SET_MESSAGES, [])
        commit(SET_PAGINATION, null)
        commit(SET_CLAIM_MESSAGE_UNCOMPLETED_COUNT, null)
        return new Promise((resolve, reject) => {
            messageApiService
                .findForClaim(payload)
                .then(response => {
                    //commit(SET_MESSAGES, response.data)
                    //commit(SET_PAGINATION, response.data.pagination)
                    //resolve(response.data.data);
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data, pagination } = apiResponse
                            commit(SET_MESSAGES, data.messages)
                            commit(SET_PAGINATION, pagination)
                            commit(SET_CLAIM_MESSAGE_UNCOMPLETED_COUNT, data.messageTaskUncompletedCount)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    fetchEmailDocument({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .getEmailDocument(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            commit(SET_SELECTED_DOCUMENT, data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error)
                })
                .finally(() => commit(LOADING, false));
        });
    },
    linkMessageToClaim({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .linkToClaim(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    console.log('response.status: ', response.status)
                    console.log('apiResponse: ', apiResponse)
                    //console.log('data: ', data)

                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    if (error.response.status == 404) {
                        resolve(error.response.data.apiResponse)
                    } else {
                        reject(error)
                    }                    
                })
                .finally(() => commit(LOADING, false));
        });
    },
    fetchAddressesForClaim({ commit }, payload) {
        commit(LOADING, true)
        commit(SET_EMAIL_ADDRESES, [])
        return new Promise((resolve, reject) => {
            messageApiService
                .getEmailAddressList(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            commit(SET_EMAIL_ADDRESES, data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    sendEmail({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .sendEmail(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            console.log('sendEmail: ', data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    fetchTagsForClaimMessage({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .getTagsForClaimMessage(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    setTagsFlorClaimMessage({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .setTagsForClaimMessage(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    resolve(apiResponse)
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    if (reject)
                        reject(error)
                })
        })
    },
    fetchAttachmentsForClaim({ commit }, payload) {
        commit(LOADING, true)
        commit(SET_SELECTEDCLAIM_ATTACHMENTS, [])
        return new Promise((resolve, reject) => {
            messageApiService
                .findAttachmentsForClaim(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            commit(SET_SELECTEDCLAIM_ATTACHMENTS, data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    fetchClaimsWithMessagesUnread({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .getClaimsWithMessageUnread(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            //commit(SET_CLAIM_MESSAGES_UNREAD, data)
                            commit('setClaimsList', data, { root: true }) 
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    commit('setClaimsList', [], { root: true }) 
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    previewEmail({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .previewEmail(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            commit(SET_MESSAGE_PREVIEW, data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    fetchDocumentTypes({ commit }) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .getDocumentTypes()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            commit(SET_DOCUMENT_TYPES, data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    setDocumentTypeForAttachment({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .setDocumentTypeForAttachment(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    commit(UPDATE_SELECTEDCLAIM_ATTACHMENT, apiResponse.data)
                    resolve(apiResponse)
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    if (reject)
                        reject(error)
                })
        })
    },
    fetchClaimsWithMessagesUncompleted({ commit }, payload) {
        commit(LOADING, true)
        commit('setSelectedClaim', null, { root: true })
        commit('setClaimsList', null, { root: true })
        return new Promise((resolve, reject) => {
            messageApiService
                .getClaimsWithMessageUncompleted(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data, pagination } = apiResponse
                            //commit(SET_CLAIM_MESSAGES_UNREAD, data)
                            commit('setClaimsList', data, { root: true })
                            commit('setPagenation', pagination, { root: true })
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    commit('setClaimsList', null, { root: true })
                    reject(error);
                })
                .finally(() => commit(LOADING, false))
        });
    },
    setMessageCompleteTask({ commit }, payload) {
        commit(LOADING, true)
        return new Promise((resolve, reject) => {
            messageApiService
                .setMessageCompletedTask(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    //commit(UPDATE_SELECTEDCLAIM_ATTACHMENT, apiResponse.data)
                    resolve(apiResponse)
                })
                .catch(error => {
                    commit(SET_ERROR, error)
                    if (reject)
                        reject(error)
                })
        })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}